import { render, staticRenderFns } from "./ModuleForm.vue?vue&type=template&id=414c1462&"
import script from "./ModuleForm.vue?vue&type=script&lang=js&"
export * from "./ModuleForm.vue?vue&type=script&lang=js&"
import style0 from "./ModuleForm.vue?vue&type=style&index=0&id=414c1462&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports